module.exports = __webpack_public_path__ + "img/compensation_benchmarking_chart.e8422943.jpg";